<template>
  <div class='damagesdamage' >
    <div v-show="!isEditing">
      
      <div class="damage_actions">
        	<span class='right floated edit icon' v-on:click="showForm">
				<i class='fa fa-pencil'></i>
			</span>
			<span class='right floated trash icon' v-on:click="deleteDamage(damage)">
				<i class='fa fa-close'></i>
			</span>
      </div>
      <div class="damage_meta">
	      {{getFormattedDate(damage) }} von {{damage.username}}:
      </div>
      <div class="damagetext" v-on:change="changeDamage" v-html="getFormattetDamage( damage.damage )">
         
      </div>      

    </div>
    
    <div class="editDamageBox" v-show="isEditing">
      <div class='form'>
          <textarea type='text' v-model="damage.damage" ></textarea>
          <button class="button is-small" v-on:click="hideForm">
            <i class="fa fa-check"></i>
          </button>
      </div>      
    </div>
    
  </div>
</template>

<script type="text/javascript">
  export default {
    props: ['damage'],
    data() {
      return {
        isEditing: false,
        currentDate:  new Date(),
        yesterday: (function(d){ d.setDate(d.getDate()-1); return d})(new Date),
        
      };
    },
    methods: {
	  getFormattedDate(damage){
		  this.FormattedDate = damage.userdate
		  var d = new Date( damage.created )
		  if( d.toLocaleDateString() == this.currentDate.toLocaleDateString() )  return 'Heute'
		  if( d.toLocaleDateString() == this.yesterday.toLocaleDateString() )  return 'Gestern'
		  return this.FormattedDate
	  }, 
	    
	  changeDamage(){
		console.log('change damage');	    
	  },
	  getFormattetDamage(damage){
		  return damage.replace(new RegExp('\r?\n','g'), '<br>')
	  },
      deleteDamage(damage) {
        this.$emit('delete-damage', damage);
      },
      showForm() {
        this.isEditing = true;
      },
      hideForm() {
        this.isEditing = false;
      },
    },
  };
</script>